import { gql } from '@apollo/client';

export const FETCH_DEADHEADS = gql`
	query deadheadRidesSearch($pagination: PaginationInput!, $filter: DeadheadSearchFilter!) {
		deadheadSearch(pagination: $pagination, filter: $filter) {
			results {
				id
				busId
				partnershipId
				relatedRideId
				rideNumber
				departure {
					address
					timezone
					stationDetails {
						code
						name
					}
					plannedTimestamp
					actualTimestamp
				}
				arrival {
					address
					stationDetails {
						code
						name
					}
					plannedTimestamp
					actualTimestamp
				}

				partnerId
				mobilityPartner {
					id
					shortName
					contractPartnerName
				}
				plateNumber
				busNumber
				status
				type
				crewMember {
					id
					fullName
				}
			}
			page {
				page
				size
				totalPages
				totalCount
			}
		}
	}
`;
